import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, RoutingModule, UrlModule } from '@spartacus/core';
import { OutletModule } from '@spartacus/storefront';
import { ProductReplacementComponent } from './product-replacement.component';

@NgModule({
  declarations: [ProductReplacementComponent],
  imports: [
    CommonModule,
    OutletModule,
    I18nModule,
    UrlModule,
    RoutingModule,
    RouterModule,
    MatTooltipModule,
    MatIconModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductReplacementComponent: {
          component: ProductReplacementComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [ProductReplacementComponent],
})
export class ProductReplacementModule {}
